var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsNumber, IsObject, IsString, IsUUID } from 'class-validator';
import { ChallengeType } from '../enums/challenge-type.enum.js';
import { OfficeAchievementLevelFullSizeDto } from './office-achievement-level.full-size.dto.js';
export class OfficeAchievementLevelChallengeFullSizeDto {
    id;
    createdAt;
    updatedAt;
    challengeLabel;
    currentCount;
    totalCount;
    challengeType;
    officeAchievementLevel;
    officeAchievementLevelId;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "challengeLabel", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "currentCount", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "totalCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "challengeType", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeAchievementLevelFullSizeDto),
    Expose(),
    __metadata("design:type", OfficeAchievementLevelFullSizeDto)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "officeAchievementLevel", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelChallengeFullSizeDto.prototype, "officeAchievementLevelId", void 0);
//# sourceMappingURL=office-achievement-level-challenge.full-size.dto.js.map